import analytics from '@utils/analytics';
import einsteinutils from '@utils/einsteinutils';
import useBreakpoint from '@utils/useBreakpoint';
import axios from 'axios';
import classNames from 'classnames';
import React, { useEffect, useMemo, useState } from 'react';
import SwiperCore, { Autoplay, Keyboard, Navigation, Mousewheel } from 'swiper';
import { SwiperSlide } from 'swiper/react';
import ProductTile from '@moncler/components/listing/ProductTile';
SwiperCore.use([Keyboard, Navigation, Autoplay, Mousewheel]);
import AutoplayCarousel from '../autoplayCarousel/AutoplayCarousel';
const timing = 10000;
const minSlidesForAutoplay = 5;
const autoplayConfig = {
    delay: 0,
    disableOnInteraction: false,
};
const ProductRecommendation = (props) => {
    const currentBreakpoint = useBreakpoint();
    const [recommenderName, setRecommenderName] = useState();
    const [title, setTitle] = useState();
    const [products, setProducts] = useState([]);
    const [loaded, setLoaded] = useState();
    const hasMinSlides = useMemo(() => {
        return products.length >= minSlidesForAutoplay;
    }, [products]);
    const recommenderCallback = (rec) => {
        setRecommenderName(rec || 'not configured');
    };
    useEffect(() => {
        const cancelTokenSource = axios.CancelToken.source();
        // console.info('parte il fetch ai reccommended products per il prodotto');
        einsteinutils.productRecommendationsFromSlot(props.slot, recommenderCallback, (rec) => {
            var _a;
            const recommendedAreChanged = JSON.stringify(products === null || products === void 0 ? void 0 : products.map((el) => el.id).sort()) !== JSON.stringify((_a = rec === null || rec === void 0 ? void 0 : rec.products) === null || _a === void 0 ? void 0 : _a.map((el) => el.id).sort());
            if (recommendedAreChanged) {
                // best way to decode special characters
                let txt = document.createElement('textarea');
                txt.innerHTML = rec.displayMessage;
                setTitle(txt.value || props.title);
                setProducts(rec.products);
                setLoaded(true);
                if (rec.products.length > 0) {
                    let pdpClass = (props === null || props === void 0 ? void 0 : props.product) ? '_pdp' : '';
                    if (props.slot === 'recommendations-recentlyviewed') {
                        analytics.productImpressionsRecommended(rec.products, `recently_my_monclert${pdpClass}`);
                    }
                    else if (props.slot === 'recommendations-profile') {
                        analytics.productImpressionsRecommended(rec.products, `recommended_my_monclert${pdpClass}`);
                    }
                    else {
                        // pdpClass = pdpClass.concat('_', slugify(rec.displayMessage));
                        pdpClass = pdpClass + '_' + props.slot;
                        analytics.productImpressionsRecommended(rec.products, `recommended${pdpClass}`);
                    }
                }
            }
        }, cancelTokenSource, props === null || props === void 0 ? void 0 : props.product, props === null || props === void 0 ? void 0 : props.productList);
        return () => cancelTokenSource.cancel();
    }, [props.slot, props === null || props === void 0 ? void 0 : props.product]);
    const loopedSlidesActive = useMemo(() => {
        if (currentBreakpoint >= 1024) {
            return products.length > 4;
        }
        if (currentBreakpoint >= 600) {
            return products.length > 3;
        }
        return products.length > 2;
    }, [products, currentBreakpoint]);
    const swiperConf = useMemo(() => {
        return {
            enabled: products.length >= 2,
            loop: loopedSlidesActive,
            watchSlidesProgress: true,
            speed: hasMinSlides ? timing : 400,
            slidesPerView: props.customClasses === 'pdp-recommendation' ? 'auto' : 1.7,
            resistance: true,
            resistanceRatio: 0,
            spaceBetween: 4,
            autoplay: hasMinSlides ? autoplayConfig : false,
            mousewheel: {
                forceToAxis: true,
                thresholdDelta: 20,
            },
            breakpoints: {
                600: {
                    slidesPerView: 3,
                    enabled: products.length > 3,
                },
                1024: {
                    slidesPerView: 4,
                    enabled: products.length > 4,
                },
            },
        };
    }, [products, loopedSlidesActive, hasMinSlides]);
    if (!loaded || products.length === 0) {
        return window.devmode ? (React.createElement("div", { className: "devmode devmodebox" },
            "RECOMMENDATION SLOT ",
            props.slot,
            " ",
            recommenderName && `recommender: ${recommenderName}`,
            " ",
            (products === null || products === void 0 ? void 0 : products.length) === 0 && '- NO RECOMMENDATIONS RECEIVED')) : (React.createElement(React.Fragment, null));
    }
    return (React.createElement("section", { className: classNames('product-recommended', { 'has-autoplay': hasMinSlides }, props.customClasses), "data-recommender": recommenderName },
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "product-recommended__title-wrapper" },
                React.createElement("h2", { className: "product-recommended__title" }, title || ''))),
        React.createElement(AutoplayCarousel, { swiperConf: swiperConf, withArrows: hasMinSlides, beforeContainer: hasMinSlides && 'pauseBtn' }, products === null || products === void 0 ? void 0 : products.map((product, i) => (React.createElement(SwiperSlide, { key: product.id },
            React.createElement(ProductTile, { withCarousel: true, noSwatch: true, product: product, type: "RECS", index: i, recommender: props.slot, hideWishlistBtn: true, hideCarouselPagination: currentBreakpoint < window.mqObj.lg })))))));
};
export default ProductRecommendation;
